var React = require('react');
var ReactDOM = require('react-dom');
import Form from 'components/form';

class ImportSubscriberForm extends React.Component {


  constructor(props) {
    super(props);
    this.state = {'filepickerId': '', 'filename': ''};
  }

  render() {
    return (
      <div className="modal hide fade modal-import-subscribers" id="modal-import-subscribers" style={{display: 'none'}}>
        <div className="modal-header">
          <a href="#" data-dismiss="modal" className="close">×</a>

          <h3>Import subscribers</h3>
        </div>

        <Form method='POST' action={this.props.import_subscribers_page_url} onSubmit={this.onSubmit.bind(this)} ref="input_subscribers_form">
          <div className="modal-body form-horizontal">
            <p>
              Import many subscribers at once by uploading a <em>.csv</em> file. Before you get started, keep the
              following in mind:
            </p>
            <ul className="styled">
              <li>The only allowed file type is a .csv (not a .numbers or .xlsx)</li>
              <li>The file must be under 20Mb in size</li>
              <li>The upload might take a while; we'll email you when it's done</li>
              <li><a href={this.props.download_template_page_url}>Download this import template</a> to see how to
                organize your .csv
              </li>
              <li><a href="http://help.statuspage.io/knowledge_base/topics/importing-subscribers-via-csv">Check out this
                article</a> for more details on specifics for each field
              </li>
            </ul>
            {this.error()}
            <div className="file-upload-container">
              <input type="file" ref="csv_file" accept="text/csv" id="csv_file" />
              <input type="hidden" name="filepicker_id" value={this.state.filepickerId} />
              <input type="hidden" name="filename" value={this.state.filename} />
            </div>
            {this.progress()}
          </div>
          <div className="modal-footer">
            <button className="cpt-button style-primary" id="btn-import-subscribers">Import subscribers</button>
          </div>
        </Form>
      </div>
    )
  }

  error() {
    if (!this.state.error) {
      return null;
    }

    return (
      <div className="cpt-notification error in-page no-delivery-types-error" style={{'marginBottom': '1rem'}} >
        {this.state.error}
      </div>
    );
  }

  progress() {
    if (!this.state.progress) {
      return null;
    }
    return (
      <div className="cpt-progress" style={{'marginTop': '1rem'}} >
        <div className="bar" style={{width: this.state.progress + '%'}}></div>
      </div>
    );
  }

  onSubmit(e) {
    e.preventDefault();
    var fileInput = ReactDOM.findDOMNode(this.refs.csv_file);

    if (fileInput.files.length == 0){
      this.setErrorMessage("Please provide a CSV file to import.");
      return
    }

    var maxSize = 20 * 1024 * 1024;
    // Check the size of the file to make sure it's not too large if the browser supports the check
    if (window.FileReader && fileInput.files) {
      if (fileInput.files[0].size > maxSize) {
        // Add an error message and return
        this.setErrorMessage("You can't upload files larger than 20Mb.");
        return
      }
    }

    filepicker.setKey(this.props.filepicker_key);
    filepicker.store(
      fileInput,
      {
        mimetype: 'text/csv'
      },
      (FPFile) => {
        // Update the progress bar
        this.setState({'progress': 100});
        // Remove the progress bar shortly after completion
        setTimeout(() => {
          this.setState({'progress': null});
        }, 150);

        // Check that the file uploaded wasn't larger than what we want to process
        if (FPFile.size && (FPFile.size > maxSize)) {
          this.setErrorMessage("You can't upload files larger than 20Mb.");
          return
        }
        var urlsParts = FPFile.url.split("/");
        var filepickerId = urlsParts[urlsParts.length - 1];
        var filename = FPFile.filename;
        this.setState({'filepickerId': filepickerId, 'filename': filename},() => {
          ReactDOM.findDOMNode(this.refs.input_subscribers_form).submit();
        });
      },
      (FPError) => {
        this.setErrorMessage(FPError.toString());
      },
      (progress) => {
        this.setState({'progress': progress});
      }
    );
  }

  setErrorMessage(errorMessage) {
    this.setState({'error': errorMessage});
    // Only show the error message for 4 seconds
    setTimeout(() => {
      this.setState({'error': null});
    }, 4000);

  }

}

module.exports = ImportSubscriberForm;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/notifications/import_subscriber_form.jsx